import { useState, useEffect } from "react";
import { createModel } from "hox";
import { useMap } from 'ahooks';
import { ISelectOption, ITreeData } from "@src/components/YhFormBox/Types";
import { rosterService } from "../../rosterService";
import { roleService } from "@src/views/authPortal/auth/role/RoleService";
import { dictService } from "@src/views/authPortal/base/dict/DictService";
import { orgService } from "@src/views/authPortal/base/org/OrgService";
import { storeService } from "@src/views/authPortal/base/store/StoreService";
import { useNavModel } from "@src/model/navModel";
import { formatFileList } from "@src/utils/uploadUtils";
import { getBaseImgLookUrl } from '@src/utils/constants';
import moment from "moment";

export const rosterDetailsModels = createModel(function () {
    const { closeNav, addNav, findNav, navTabs } = useNavModel();

    const [userTypeDs, setUserTypeDs] = useState<ISelectOption[]>();
    const [baseTypeDs, setBaseTypeDs] = useState<ISelectOption[]>();

    const [hukouTypeDs, setHukouTypeDs] = useState<ISelectOption[]>();
    const [hujiTypeDs, setHujiTypeDs] = useState<ISelectOption[]>();
    const [educationalTypeDs, setEducationalTypeDs] = useState<ISelectOption[]>();
    const [certificateTypeDs, setCertificateTypeDs] = useState<ISelectOption[]>();

    const [contraceHoldTypeDs, setContraceHoldTypeDs] = useState<ISelectOption[]>();
    const [contraceTypeDs, setContraceTypeDs] = useState<ISelectOption[]>();
    const [socialSecurityTypeDs, setSocialSecurityTypeDs] = useState<ISelectOption[]>();

    const [skillLevelTypes, setSkillLevelTypesDs] = useState<ISelectOption[]>();
    const [salaryTypes, setSalaryTypesDs] = useState<ISelectOption[]>();

    const [storeDs, setStoreDs] = useState<ISelectOption[]>();
    const [roleDs, setRoleDs] = useState<ISelectOption[]>();
    const [orgDs, setOrgDs] = useState<ITreeData[]>();

    const [formInfo, { set: setFormInfo, get: getFormInfo }] = useMap<string, any>([]);
    // 合同信息
    const [contract, setContract] = useState<any>();
    const [contracts, setContracts] = useState<any[]>([]);
    //薪酬信息
    const [salary, setSalary] = useState<any>();
    const [salarys, setSalarys] = useState<any[]>([]);

    const loadDs = async (type: string) => {
        if (type === "baseInfo") {
            const userTypes = await dictService.dictItemDs('user-type');
            const baseTypes = await dictService.dictItemDs('base');
            const roleds = await roleService.roleDs({});
            const orgds = await orgService.orgTreeDs({});
            const storeds = await storeService.storeDs({});

            setUserTypeDs(userTypes);
            setBaseTypeDs(baseTypes);
            setOrgDs(orgds);
            setRoleDs(roleds);
            setStoreDs(storeds);
        }
        if (type === "employeeInfo") {
            const hukouTypes = await dictService.dictItemDs('hukou');
            const hujiTypes = await dictService.dictItemDs('registered residence');
            const educationalTypes = await dictService.dictItemDs('educational');
            const certificateTypes = await dictService.dictItemDs('Certificate');
            setHukouTypeDs(hukouTypes);
            setHujiTypeDs(hujiTypes);
            setEducationalTypeDs(educationalTypes);
            setCertificateTypeDs(certificateTypes);
        }
        if (type === "contractInfo") {
            const contraceHoldTypes = await dictService.dictItemDs('Contract type');
            const contraceTypes = await dictService.dictItemDs('type of contract');
            const socialSecurityTypes = await dictService.dictItemDs('insurance');
            setContraceHoldTypeDs(contraceHoldTypes);
            setContraceTypeDs(contraceTypes);
            setSocialSecurityTypeDs(socialSecurityTypes);
        }
        if (type === "salaryFile") {
            const skillLevelTypes = await dictService.dictItemDs('Skill level');
            const salaryTypes = await dictService.dictItemDs('Salary type');
            setSkillLevelTypesDs(skillLevelTypes);
            setSalaryTypesDs(salaryTypes);
        }

    }

    const getDetail = async (id: string, mode: string) => {
        const { retData } = await rosterService.getDetail({ "id": id });
        setFormInfo(mode, {
            ...retData,
            status: retData?.status === 0,
            shops: retData.shops?.map((e: any) => e.code),
            roles: retData.roles?.map((e: any) => e.code),
            birthDate: retData.birthDate ? moment(retData.birthDate, 'YYYY-MM-DD HH:mm:ss') : null,
            hireDate: retData.hireDate ? moment(retData.hireDate, 'YYYY-MM-DD HH:mm:ss') : null,
            terminationDate: retData.terminationDate ? moment(retData.terminationDate, 'YYYY-MM-DD HH:mm:ss') : null,
            idValidity: retData.idValidity ? moment(retData.idValidity, 'YYYY-MM-DD HH:mm:ss') : null,
            graduationDate: retData.graduationDate ? moment(retData.graduationDate, 'YYYY-MM-DD HH:mm:ss') : null,
            userFileList: formatFileList(retData.userFileListId),
            mainFileList: formatFileList(retData.userFileListOth?.filter((e: any) => e.type === "five_major_files")),
            extraFileList: formatFileList(retData.userFileListOth?.filter((e: any) => e.type === "related_files")),
        })
        setContracts(retData?.userContractsVoList);
        setContract({
            ...retData.userContractsVoList?.[0],
            num: retData.userContractsVoList?.[0].num ?? 0,
            startDate: retData.userContractsVoList?.[0].startDate ? moment(retData.userContractsVoList?.[0].startDate) : null,
            endDate: retData.userContractsVoList?.[0].endDate ? moment(retData.userContractsVoList?.[0].endDate) : null,
            userFileList: formatFileList(retData.userContractsVoList?.[0].userFileList),
        });

        setSalarys(retData?.userSalaryRecordsList);
        setSalary({
            ...retData.userSalaryRecordsList?.[0],
            startDate: retData.userSalaryRecordsList?.[0].startDate ? moment(retData.userSalaryRecordsList?.[0].startDate) : null,
            endDate: retData.userSalaryRecordsList?.[0].endDate ? moment(retData.userSalaryRecordsList?.[0].endDate) : null,
            userFileList: formatFileList(retData.userSalaryRecordsList?.[0].userFileList),
        });
    }

    const onCancel = (mode: string) => {
        const currentNavId = mode === "add" ? "portal-03-04-01" : "portal-03-04-02";
        const parentNavId = "portal-03-04";

        // 检查父级导航是否存在
        const parentNav = findNav(parentNavId);
        if (parentNav) {
            // 如果父级导航存在，先关闭当前页面，再打开父级页面
            closeNav(currentNavId);
            addNav(parentNavId);
        } else {
            // 如果父级导航不存在，跳转到最后一个标签页
            const lastNav = navTabs[navTabs.length - 2];
            if (lastNav && lastNav.code !== currentNavId) {
                closeNav(currentNavId);
                addNav(lastNav.code);
            } else {
                // 如果没有其他标签页，跳转到首页
                closeNav(currentNavId);
                addNav("portal-03-04");
            }
        }
    }

    const guid = () => {
        const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0,
                v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
        return uuid.replaceAll("-", "");
    }

    return {
        loadDs, getDetail, onCancel, guid,
        setFormInfo, getFormInfo,
        baseTypeDs, userTypeDs, orgDs, storeDs, roleDs,
        hukouTypeDs, hujiTypeDs, educationalTypeDs, certificateTypeDs,
        contraceHoldTypeDs, contraceTypeDs, socialSecurityTypeDs,
        skillLevelTypes, salaryTypes,
        contract, contracts, setContracts,
        salary, salarys, setSalarys,
    }
})